import usePluginEntities from "hooks/usePluginEntities";
const usePluggableEntityShareFormGroup = () => {
  var _a;
  const pluggableCollection = usePluginEntities("components.collection");
  const collection = pluggableCollection == null ? void 0 : pluggableCollection[0];
  const conditionMet = (collection == null ? void 0 : collection.useCondition) ? collection.useCondition() : true;
  if (!conditionMet) return null;
  return (_a = collection == null ? void 0 : collection.AddCollectionFormGroup) != null ? _a : null;
};
export default usePluggableEntityShareFormGroup;
